export async function delay(millis: number) {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), millis));
}
